import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Slider from "@mui/material/Slider";

interface AudioSliderProps {
  value: number;
  onChange: (event: Event, newValue: number | number[]) => void;
}

export default function AudioSlider({ value, onChange }: AudioSliderProps) {
  // Show "aura" (wave effect) only when volume is at 50% or below
  const showAura = value <= 50;

  return (
    <Box sx={{ width: 60, marginLeft: 0.5 }}>
      <Stack spacing={1} direction="row" sx={{ alignItems: "center", color: "white" }}>
        <Slider
          aria-label="Volume"
          value={value}
          onChange={onChange}
          min={0}
          max={100}
          sx={{
            color: "white",
            "& .MuiSlider-thumb": {
              width: 12,
              height: 12,
              "&:hover": {
                boxShadow: showAura ? "0 0 0 6px rgba(255, 255, 255, 0.16)" : "none",
              },
              "&.Mui-active": {
                boxShadow: showAura ? "0 0 0 6px rgba(255, 255, 255, 0.16)" : "none",
              },
              "&.Mui-focusVisible": {
                boxShadow: showAura ? "0 0 0 6px rgba(255, 255, 255, 0.16)" : "none",
              },
            },
            "& .MuiSlider-rail": {
              height: 2,
            },
            "& .MuiSlider-track": {
              height: 2,
            },
          }}
        />
      </Stack>
    </Box>
  );
}

{
  /*  <Box sx={{ width: 100 }}>
 <Stack spacing={1} direction="row" sx={{ alignItems: "center", color: "white" }}>
    <Slider size="medium" aria-label="Volume" value={value} onChange={handleChange} sx={{ color: "white" }} />
    </Stack>
    </Box> */
}
